import wrapWithProvider from './wrap-with-provider.tsx';
export const wrapRootElement = wrapWithProvider;
